import type { ReciprocityEffectiveStatus, ReciprocityRequestAdminItem } from './types';

const todayIso = () => new Date().toISOString().slice(0, 10);

type Item = Omit<ReciprocityRequestAdminItem, 'effectiveStatus'> & { effectiveStatus?: ReciprocityEffectiveStatus | undefined };

/**
 * What a reciprocity request means today. The server's `effectiveStatus` wins when it sends one; otherwise it is derived the same way the server does:
 * Expired is never stored, it is an Approved request whose expiry date has been reached. Dates are yyyy-mm-dd strings, compared as text.
 */
export function effectiveStatusOf(item: Item, today: string = todayIso()): ReciprocityEffectiveStatus {
  if (item.effectiveStatus) return item.effectiveStatus;
  switch (item.status) {
    case 'Revoked':
      return 'Revoked';
    case 'Rejected':
      return 'Rejected';
    case 'Withdrawn':
      return 'Withdrawn';
    case 'SubmittedPendingReview':
      return item.isStale ? 'Stale' : 'Pending';
    case 'Approved': {
      if (item.isStale) return 'Stale';
      const expires = item.expiresOn?.slice(0, 10);
      if (item.isExpired || (expires && expires <= today)) return 'Expired';
      const from = item.effectiveFrom?.slice(0, 10);
      return from && from > today ? 'EffectiveInFuture' : 'InEffect';
    }
  }
}
